module.exports = __webpack_public_path__ + "img/star.4152e020.svg";